<div class="carousel py-[30px]">
  <div class="carousel-track gap-[30px]" #carouselTrack>
    @for (clone of [1,2,3,4]; track clone) {
      @for (image of images; track image; let i = $index) {
        <img
          (click)="openInstagram()"
          [src]="image"
          class="footer-image cursor-pointer"
          [alt]="'Image ' + i" />
      }
    }
  </div>
</div>
